import { useSendSignMulti } from "../mutate-hooks/use-send-sign-multi";

type UseSendSignEntryMultiModalProps = {
  sectionOneId: string;
  sectionOneListId: string;
  search?: string;
  handleClose: () => void;
};

export const useSendSignEntryMultiModal = ({
  sectionOneId,
  sectionOneListId,
  search,
  handleClose,
}: UseSendSignEntryMultiModalProps) => {
  const { sendMany } = useSendSignMulti(sectionOneId, search, handleClose);

  const handleSend = ({
    itemsIds,
  }: {
    itemsIds: { itemNoVersionId: string; selected: boolean }[];
  }) => {
    const bodyItems = itemsIds.map((item) => ({
      itemNoVersionId: item.itemNoVersionId,
      selected: item.selected,
    }));

    const body = {
      itemsIds: bodyItems,
    };

    sendMany({
      params: {
        path: {
          sectionOneListId,
        },
      },
      body,
    });
  };

  return { handleSend };
};
